module.exports = __webpack_public_path__ + "static/img/video-blank.c4837dbd.png";